import {
  FunctionComponent,
  ChangeEvent,
  useState,
  SyntheticEvent,
  useEffect,
} from "react";
import { toast } from "react-toastify";
import { RTABAK_URLS } from "../../../../../utils/urls";
import "./CreateHighlightedSearch.scss";
import request from "../../../../../services/request";

type Props = {
  setNewHighlightedSearch: React.Dispatch<React.SetStateAction<any>>;
};

const CreateHighlightedSearch: FunctionComponent<Props> = ({
  setNewHighlightedSearch,
}) => {
  const [disable, setDisable] = useState<boolean>(true);
  const [highlightedSearch, setHighlightedSearch] = useState<Search>({
    search: "",
    _id: "",
  });

  useEffect(() => {
    highlightedSearch.search.length > 3 ? setDisable(false) : setDisable(true);
  }, [highlightedSearch]);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    setHighlightedSearch({
      ...highlightedSearch,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e: SyntheticEvent) => {
    e.preventDefault();
    return request({
      baseURL: RTABAK_URLS.API.PostHighlightedSearch,
      method: "POST",
      data: highlightedSearch,
    }).then((response) => {
      toast.success("Agregado correctamente");
      setNewHighlightedSearch(true);
      setHighlightedSearch({
        search: "",
        _id: "",
      });
      return response;
    });
  };

  return (
    <form onSubmit={handleSubmit} className="createHighlightedSearchForm">
      <label htmlFor="search">
        Nombre sugerido:
        <input
          type="text"
          name="search"
          id="search"
          onChange={handleChange}
          value={highlightedSearch.search}
        />
      </label>
      <button type="submit" disabled={disable}>
        Agregar
      </button>
    </form>
  );
};

export default CreateHighlightedSearch;
